export const setTestHeaders = (config) => {
  if (window.ENV === 'test') {
    if (window.GlobalDate.isActive) {
      config.headers.mockdate = window.GlobalDate.getMockDateString()
    }
  }

  return config
}
